import regExp from '@shared/utils/helpers/regular-expressions'

export const parseUserIds = (text?: string): string[] => {
  return (
    text
      ?.match(regExp.usersIdsFromString)
      ?.map((bracketedValue) => bracketedValue.slice(2, -2)) ?? []
  )
}
